import React from "react";
import Button from "../../components/Button";
import styles from "./ErrorScreen.module.css";

const ErrorScreen = ({ message, refetch }) => {
  return (
    <div className={styles.container}>
      <img
        src="https://res.cloudinary.com/crown-interactive/image/upload/v1649694750/error_zqm3cr.png"
        alt=""
      />
      <p className={styles.message}>{message}</p>
      {refetch && <Button onClick={() => refetch()}>Reload</Button>}
    </div>
  );
};

export default ErrorScreen;
